import { View } from "@react-pdf/renderer";
import { useMemo } from "react";

const PdfColumn = ({ children, gap = 1, style }) => {
  const styles = useMemo(() => {
    return {
      flexDirection: "column",
      // marginBottom: 14,
      gap: gap,
      ...style,
    };
  }, [style, gap]);

  return <View style={styles}>{children}</View>;
};

export default PdfColumn;
